import { Caption, Photo } from 'components/landing/Hindisvik/styles';
import { Eigendur, Hero, Hindisvik, Notice, Nu, Sogubrot } from 'components/landing';
import { Layout, SEO } from 'components/common';

import { Header } from 'components/theme';
import Image from 'components/common/Image';
import React from 'react';

export default ({ pageContext: { lang } }) => (
  <Layout>
    <SEO
      title={lang === 'is' ? 'Hindisvík – jörð yst á Vatnsnesi' : 'Hindisvík – a farm on Vatnsnes, Iceland'}
      location={lang === 'is' ? '/' : '/en/'}
    />
    <Header />
    <main>
      <Hero />
      <Notice />
      <Hindisvik />
      <Photo>
        <Image file="hvik_pabbi_1.jpg" alt={lang === 'is' ? 'Hliðið að Hindisvík' : 'The gate to Hindisvík'} />
        <Caption>{lang === 'is' ? 'Hliðið að Hindisvík' : 'The gate to Hindisvík'}</Caption>
      </Photo>
      <Eigendur />
      <Photo>
        <Image file="hvik_pabbi_2.jpg" alt={lang === 'is' ? 'Tjaldur á steini' : 'An oystercatcher on a rock'} />
        <Caption>{lang === 'is' ? 'Tjaldur í fjörunni' : 'An oystercatcher on the shore'}</Caption>
      </Photo>
      <Sogubrot />
      <Nu />
    </main>
  </Layout>
);
